<sm-title-bar
  pageTitle="{{ 'followers_public_post.title' | translate }}"
  [backWithParams]="true"
>

</sm-title-bar>


<div
  *ngIf="!isLoading"
  class="row row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 g-4"
>
  <div class="col" *ngFor="let post of publicPostsData">
    <sm-admin-post-card
      [postData]="post"
      (onOpenModel)="openModel($event)"
    ></sm-admin-post-card>
  </div>
</div>
<!-- <mat-paginator
  class="mt-4"
  [length]="totalData"
  [pageSize]="8"
  (page)="onPageChange($event)"
>
</mat-paginator> -->

<div *ngIf="!isLoading && publicPostsData.length > 0" style="margin-top: 50px;">
  <hr style="    color: #7c7c7c;">
  <div class="row" style="text-align: center; color: #7c7c7c;">
    <span>{{ 'followers_public_post.placeholder_2' | translate }}</span>
  </div>
</div>
